import { ComponentState } from '../../../types/ComponentStates.types';
import { LabeledComponent, LabeledComponentProperties, LabeledComponentProps } from '../inputs/LabeledComponent';
import Datepicker, { DatepickerProps } from './Datepicker';

interface LabeledProps extends Omit<LabeledComponentProps, 'children'> {
  errorMessage?: string | undefined;
}

interface LabeledStateDatepickerProps {
  id: string;
  state: ComponentState;

  labeledProps: LabeledProps;
  datepickerProps: DatepickerProps;
}

export const LabeledStateDatepicker = ({ id, labeledProps, datepickerProps, state }: LabeledStateDatepickerProps) => {
  const { errorMessage, stateProperties: labeledStateProperties } = labeledProps;

  const myStateProperties: LabeledComponentProperties = {
    error: {
      message: errorMessage,
      color: 'text-error',
    },
    default: {},
    ...labeledStateProperties,
  };

  const labeledComponentProps = {
    id,
    state,
    stateProperties: myStateProperties,
    ...labeledProps,
  };

  return (
    <LabeledComponent {...labeledComponentProps}>
      <Datepicker {...datepickerProps} />
    </LabeledComponent>
  );
};
